window.__INITIAL_STATE__ = {
  app: {
    environment: getEnvironmentFromURL(),
    isMicrophoneRecommended: true,
    isCameraRecommended: true,
    isLocationRecommended: true,
    isHmtDevice: new URLSearchParams(window.location.search).has('realwear'),
    idealConstraints: {
      camera: new URLSearchParams(window.location.search).has('T21G') ? {
        width: { min: 480, ideal: 720 },
        height: { min: 854, ideal: 1280 },
        facingMode: { ideal: 'environment' },
        frameRate: { ideal: 25 }
      } : {
        width: { ideal: 1280 },
        height: { ideal: 720 },
        // Keep the camera's own picture: by default Chromium crops it to the ideal size, which turns a phone's
        // portrait picture into a 720x720 square whenever it does not detect the rotation itself
        resizeMode: 'none',
        facingMode: { ideal: 'environment' },
        frameRate: { ideal: 25 }
      },
      microphone: {
        noiseSuppression: true,
        echoCancellation: true,
        sampleRate: 48000,
      }
    }
  }
}
